import React from 'react'
import { useSuggestionButtons } from './suggestedButtonSets'
import type { Object as FabricObject } from 'fabric/fabric-impl'
import { useSelector } from 'react-redux'
import { selectEditorState } from '@/store/slices/editor/selector'
import EditWithAISuggestionsBar from './EditWithAISuggestionsBar'
import type { AIFashionButtonSetOverride } from '@/scenes/AIStudioLite/AIFashionController'

type EditWithAIButtonSetsProps = {
  isVisible: boolean
  width: number
  arrowsPlacement?: 'inside' | 'outside'
  onActionSelect: (action: string) => void
  activeObject?: FabricObject | null
  triggerGeneration?: (loadingLabel?: string) => void
  /**
   * Override for AI Fashion data (controller + target id). When supplied,
   * the component runs in "AI Studio" mode while still reading suggestion chrome
   * state from the canonical editor UI slice.
   */
  aiFashionOverride?: AIFashionButtonSetOverride
}

function EditWithAIButtonSets({ isVisible, width, arrowsPlacement: arrowsPosition, onActionSelect, activeObject, triggerGeneration, aiFashionOverride }: EditWithAIButtonSetsProps) {
  const editorState = useSelector(selectEditorState)
  const buttons = useSuggestionButtons(onActionSelect, activeObject, triggerGeneration, aiFashionOverride)

  const isGhost = editorState.suggestionsButtonSet === 'ghost'
    || (aiFashionOverride?.buttonSet === 'aiStudioVideo' && !!aiFashionOverride.videoSuggestions?.isLoading && !aiFashionOverride.videoSuggestions.items.length)

  return (
    <EditWithAISuggestionsBar
      isVisible={isVisible}
      isGhost={isGhost}
      width={width}
      arrowsPlacement={arrowsPosition}
      buttons={buttons}
      onActionSelect={onActionSelect}
    />
  )
}

export default EditWithAIButtonSets

